import * as R from 'ramda';
import React, {Component} from 'react';

import './index.scss';

export default class Rate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: props.value,
            value: props.value
        };
    }

    onRating = i => {
        const {onRating} = this.props;

        if (!this.props.controlled) {
            this.setState({defaultValue: i});
        }

        onRating(i);
    };

    renderItem = i => {
        const {icon: Icon} = this.props;
        const {defaultValue, value} = this.state;

        const props = {
            key: i,
            className: 'rate__item',
            onMouseEnter: this.props.isStatic ? () => {} : () => this.setState({value: i}),
            onMouseLeave: this.props.isStatic
                ? () => {}
                : () => this.setState({value: defaultValue}),
            onClick: () => this.onRating(i)
        };

        return (
            <div {...props}>
                <Icon filled={i <= value} />
            </div>
        );
    };

    render() {
        const {items} = this.props;
        const ratings = R.range(1, items + 1);
        return <div className="rate">{R.map(this.renderItem, ratings)}</div>;
    }
}



// WEBPACK FOOTER //
// ./components/rate/index.js